import React from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import {
  Button,
} from '../../../form/FormControls.jsx';
import { getFontColorFromBackground, UrlSimpleWrappedDiv,
  addFromTab } from '../../../../util/util.jsx';
import { connect } from 'react-redux';
import { getDealListWrapper } from '../store/DealsWrapper.js';
import PlaceNameDisplayWrapper from '@/component/dict/simple/port/NameDisplayWrapper';
import { unlinkTransport, removeDealExpense } from '../store/deal.store.js';
import vessel from '@/../style/vessel.png';
import container from '@/../style/container.png';
import railcar from '@/../style/railcar.png';
import truck from '@/../style/truck.png';
import loadport from '@/../style/loadport.png';
import unloadport from '@/../style/unloadport.png';
import { List, fromJS } from 'immutable';
import { handleFormChanged } from '@/store/allaround.store.js';
import { deleteFile } from '../store/files.store';
import { REF_PATH as EXPENSES_TYPE_REF_PATH }
  from '@/component/dict/complex/expensestype/Const';
import { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import unlink from '../../../../../style/unlink.png';


export function formatTransportName(dataArg, plainText = false, icon) {
  const data = !dataArg || dataArg.get ? dataArg : fromJS(dataArg);
  let transportName = '';
  const className = plainText ? 'small-transport-display-name-plain'
    : 'small-transport-display-name text-primary';
  const tagClassName = plainText ? 'small-transport-display-name-text plain-text-vesselname'
    : 'small-transport-display-name-text tag-alike';

  if (data && data.get('transportType') == 'CONTAINER'
    && data.get('transportNameVoyage')) {
    transportName = (<span
      className={className}
    >{icon && !plainText ? icon : ''}
      {
        data.get('transportNameVoyage').filter(elem => elem.get('vesselName')).map((elem, idx) =>
          <span
            className={tagClassName}
            style={{ maxWidth: `calc(${100 / data.get('transportNameVoyage').size
            }% - ${50 / data.get('transportNameVoyage').size}px)` }}
            key={idx}
          >
            {elem.get('vesselName')}
          </span>)
      }
    </span>);
  } else if (data) {
    transportName = (<span
      className={className}
    >{icon && !plainText ? icon : ''}
      <span className={'small-transport-display-name-text'}> {data.get('vesselName') ?
        data.get('vesselName') : ''}{' '}
      {data.get('voyageNumber') ?
        data.get('voyageNumber') : ''}
      </span>
    </span>);
  }
  return transportName;
}

export function getTransportIcon(transportType = '') {
  const iconStyle = { height: '2em', paddingRight: 10 };
  switch (transportType.toLowerCase()) {
    case 'bulk':
      return <img alt="Bulk Vessel" src={vessel} style={iconStyle} />;
    case 'container':
      return <img alt="Contrainer ship" src={container} style={iconStyle} />;
    case 'truck':
      return <img alt="Truck" src={truck} style={iconStyle} />;
    case 'railcar':
      return <img alt="Railcar" src={railcar} style={iconStyle} />;
    default:
      return '';
  }
}

class SmallTransportDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.yesButton = this.yesButton.bind(this);
    this.displayLoadingPorts = this.displayPorts.bind(this, true);
    this.displayDischargePorts = this.displayPorts.bind(this, false);
    this.linkClickHandler = this.linkClickHandler.bind(this);
    this.accessDeniedAlert = this.accessDeniedAlert.bind(this);
    this.state = { showModal: false,
      data: this.findTransport(props),
      showAccessDeniedAlert: false };
  }
  componentWillMount() {
    getDealListWrapper('transport');
    this.setState({ data: this.findTransport(this.props) });
  }
  componentWillReceiveProps(props) {
    getDealListWrapper('transport');
    this.setState({ data: this.findTransport(props) });
  }

  displayPorts(isLoadingPorts) {
    let ports;
    const data = this.state.data;
    if (!data) {
      return '';
    }
    if (data.get('transportType')) {
      switch (data.get('transportType').toLowerCase()) {
        case 'bulk':
          ports = isLoadingPorts ?
            data.get('vesselLoadingPorts', new List())
              .map(port => port.get('place')).filter(p => p || p === 0)
            : data.get('vesselDischargePorts', new List())
              .map(port => port.get('place')).filter(p => p || p === 0);
          break;
        case 'container':
        case 'railcar':
          ports = isLoadingPorts ?
            List.of(data.get('loadingPort')) : List.of(data.get('dischargePort'));
          break;
        default:
          break;
      }
    }
    return (<div>
      {ports ? ports.map((port, idxPort) =>
        <div
          key={idxPort}
        >
          <PlaceNameDisplayWrapper
            noBorder
            id={port}
          />{' '}
        </div>)
        : ''}
    </div>);
  }

  findTransport(props) {
    if (props.transportDeals) {
      if (props.link) {
        return props.transportDeals.find(deal => deal.get('id') == props.link.get('transport'));
      } return props.transportDeals.find(deal => deal.get('id') == props.transportId);
    } return undefined;
  }
  openModal(e) {
    e.stopPropagation();
    this.setState({ showModal: true });
  }
  closeModal() {
    this.setState({ showModal: false });
  }
  yesButton() {
    this.props.unlinkTransport();
    this.setState({ showModal: false });
    this.props.handleFormChanged();
  }

  accessDeniedAlert(show, onHide) {
    return (
      <Modal bsSize="sm" show={show} onHide={onHide}>
        <Modal.Body style={{ textAlign: 'center' }}>
          You have insufficient privileges for access
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onHide}>Ok</Button>
        </Modal.Footer>
      </Modal>);
  }

  linkClickHandler() {
    if (validateRoleConfig(['myTransports#1', 'allTransports#1'], this.state.data)) {
      return true;
    }
    this.setState({ showAccessDeniedAlert: true });
    return false;
  }

  render() {
    let icon = '';
    if (this.state.data && this.state.data.get('transportType')) {
      icon = getTransportIcon(this.state.data.get('transportType').toLowerCase());
    }
    const loadingPorts = this.displayLoadingPorts();
    const dischargeports = this.displayDischargePorts();
    const transportName = formatTransportName(this.state.data, false, icon);
    const rowStyle = { paddingTop: '15px' };
    return (this.state.data ? <div className="small-transport-display">
      <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal} >
        <Modal.Body>
          Are you sure you want to unlink transport?
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.yesButton}>Yes</Button>
          <Button onClick={this.closeModal}>No</Button>
        </Modal.Footer>
      </Modal>
      {this.accessDeniedAlert(this.state.showAccessDeniedAlert,
        () => this.setState({ showAccessDeniedAlert: false }))}
      <UrlSimpleWrappedDiv
        url={!this.props.disableOnClick &&
           (this.state.data.get('id') || this.state.data.get('id') === 0)
          ?
          `/deals/transport/${this.state.data.get('id')}${addFromTab()}` : undefined}
        onClick={this.props.linkMode ? undefined : this.linkClickHandler}
        className="small-transport-display-block"
      >
        <Row className={'small-transport-display-name-block'}>
          <Col sm={!this.props.viewMode ? 10 : 12}>
            {transportName}
          </Col>
          {!this.props.viewMode ?
            <Col sm={2}>
              {/* eslint-disable no-dupe-keys*/}
              <Button
                id="unlinkTransport"
                bsStyle="link"
                style={{ float: 'right', padding: '2px 0 2px 3px' }}
                onClick={this.openModal}
              >
                <img src={unlink} alt={'Unlink'} className={'unlink-icon'} />
              </Button>
              {/* eslint-enable no-dupe-keys*/}
            </Col> : ''}
        </Row>
        <Row style={rowStyle}>
          <Col
            xs={this.props.viewMode ? 6 : 12}
            className={!this.props.viewMode ? 'small-transport-ports-edit-mode' : ''}
          >
            <img src={loadport} alt={'Loading ports'} className={'small-transport-port-icon'} />
            <span className={'small-transport-port-list'} style={{ wordBreak: 'break-all' }}>
              {loadingPorts}
            </span>
          </Col>
          <Col
            xs={this.props.viewMode ? 6 : 12}
            className={!this.props.viewMode ? 'small-transport-ports-edit-mode' : ''}
          >
            <img src={unloadport} alt={'Discharge ports'} className={'small-transport-port-icon'} />
            <span className={'small-transport-port-list'} style={{ wordBreak: 'break-all' }}>
              {dischargeports}
            </span>
          </Col>
        </Row>
        <Row>
          {this.state.data.get('calendarEvents') ?
            this.state.data.get('calendarEvents').map((evt, idx) =>
              <Col
                xs={12} key={idx} style={{ border: '2px inset lightgray',
                  background: evt.get('color'),
                  margin: '5px 0px 0px 0px',
                  padding: '0px 20px',
                  color: getFontColorFromBackground(evt.get('color')) }}
              >
                <Row>
                  {evt.get('startDate') == evt.get('endDate') ? evt.get('startDate') :
                    <div>{evt.get('startDate')} - {evt.get('endDate')}</div>}
                </Row>
                <Row style={{ wordBreak: 'break-all' }}>
                  {evt.get('fullDescription')}
                </Row>
              </Col>,
            ) : ''}
        </Row>
        {this.props.disconnect ?
          <Button
            bsStyle="primary" onClick={this.props.disconnect}
            style={{ alignSelf: 'center', float: 'right', padding: '3px' }}
          >
            Unassign
          </Button>
          : ''}
      </UrlSimpleWrappedDiv>
    </div> : <div />
    );
  }
}
SmallTransportDisplay.propTypes = {
  disconnect: React.PropTypes.func,
  transportDeals: React.PropTypes.object,
  getPlaceName: React.PropTypes.func,
  viewMode: React.PropTypes.bool,
  unlinkTransport: React.PropTypes.func,
  link: React.PropTypes.object,
  transportId: React.PropTypes.number,
  disableOnClick: React.PropTypes.bool,
  handleFormChanged: React.PropTypes.func,
  type: React.PropTypes.string,
  expensestypes: React.PropTypes.object,
  productIdx: React.PropTypes.number,
  product: React.PropTypes.object,
  removeDealBulkExpense: React.PropTypes.func,
  files: React.PropTypes.object,
  deleteFile: React.PropTypes.func,
  linkMode: React.PropTypes.bool,
};

export default connect(state => ({
  transportDeals: state.getIn(['data', 'deals', 'list', 'transport']),
  expensestypes: state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List()),
  files: state.getIn(['data', 'deals', 'files', 'USUAL'], new List()),
}), (dispatch, props) => ({
  unlinkTransport() {
    unlinkTransport(dispatch, props.link);
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
  removeDealBulkExpense(productIdx, expenseId) {
    removeDealExpense(dispatch, productIdx, expenseId);
  },
  deleteFile(uuid, idx) {
    deleteFile(dispatch, 'USUAL', uuid, idx);
  },
}))(SmallTransportDisplay);
